<template>
    <div class="ticket-item">
        <a href="http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9" target="_blank" style="text-decoration:none;color: #fff;">
            <div class="type"> {{ data.type }} </div>
            <div class="price" :class="{'break-word': data.price == '￥399'}"> {{ data.price }}</div>
            <div class="content"> {{ data.info }} </div>
            <div class="buy"> 购票 </div>
        </a>
    </div>
</template>

<script>
export default{
   props:['data']
}
</script>

<style lang="scss" scoped>

.ticket-item{
    display: inline-block;
    width: 335px;
    height: 390px;
    margin-right: 30px;
    margin-left: 30px;
    margin-top: 0px;
    vertical-align: top;
    text-align: center;
    color: #fff;
    background:{
        image: url('../assets/pc/ticket-bg.png');
    }
    .type{
        font-weight: bold;
        font-size: 30px;
        text-decoration: underline;
        padding-top: 40px;
    }
    .price{
        font-weight: bold;
        font-size: 50px;
        color: #ffa700;
        padding-top: 30px;
    }
    .break-word{
        text-decoration: line-through;
    }
    .content{
        font-size: 14px;
        padding: 10px 40px;
        height: 100px;
   }
    .buy{
        margin: 0 auto;
        font-size: 22px;
        margin-top: 30px;
        width: 80px;
        background: #ffa700;
    }
}

</style>



// WEBPACK FOOTER //
// TicketItem.vue?2776c124